import { AnimatePresence } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import Hero from '../components/hero';
import About from '../components/About';
import Portfolio from '../components/portfolio';
import Experience from '../components/experience';
import Youtube from '../components/youtube';
import { Helmet } from "react-helmet-async";

function Home() {
    return (
        <>
            <Helmet>
                <title>SURYA • FRONTEND DEVELOPER</title>
                <meta name="description" content="" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>
            <Hero />
            <About />
            <Portfolio />
            <Experience />
            <Youtube />
        </>
    );
}

export default Home;